// extracted by mini-css-extract-plugin
export default {"container":"z8oXo","arrow":"_3e7UL","page":"_3Zrlh","position":"FoieI","withPosition":"_1eDVm","active":"_2LM0Z","disabled":"svwOd"};